import Button from 'components/shared/Button';
import React from 'react';
import styles from './IntervalSelectionButtons.module.scss';
import { SubscriptionPeriod } from 'features/billing/subscription/subscriptionTypes';

interface IntervalSelectionButtonsProps {
  interval: SubscriptionPeriod;
  handleIntervalChange: (interval: SubscriptionPeriod) => void;
}

const IntervalSelectionButtons: React.FC<IntervalSelectionButtonsProps> = ({ interval, handleIntervalChange }) => {
  return (
    <div className={styles.intervalButtons}>
      <Button
        variant={interval === 'year' ? 'primary' : 'default'}
        onClick={() => handleIntervalChange('year')}
      >
        Annual
      </Button>
      <Button
        variant={interval === 'month' ? 'primary' : 'default'}
        onClick={() => handleIntervalChange('month')}
      >
        Monthly
      </Button>
    </div>
  );
};

export default IntervalSelectionButtons;
